import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const inr = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  const num = Math.round(Number(n));
  return "₹" + num.toLocaleString("en-IN");
};

export const inrShort = (n) => {
  if (!n) return "₹0";
  const num = Number(n);
  if (num >= 10000000) return "₹" + (num / 10000000).toFixed(2) + "Cr";
  if (num >= 100000) return "₹" + (num / 100000).toFixed(2) + "L";
  if (num >= 1000) return "₹" + (num / 1000).toFixed(1) + "K";
  return "₹" + num;
};
